export default __webpack_public_path__ + "static/media/martin.66c3c94e.jpg";